const FRS_PATH_MAP = {
  AU: 'ua/generalconditions',
  CA: 'returnshipping/terms-and-conditions',
  DE: 'refunded-returns/terms-and-conditions',
  ES: 'refunded-returns/general-conditions',
  FR: 'refunded-returns/general-conditions',
  GB: 'refunded-returns/general-conditions',
  IT: 'refunded-returns/general-conditions',
  US: 'returns/terms',
};

const UI_STATE_FIELDS_TO_FORM_STATE_MAP = {
  cvv: 'cardCvv',
  dob: 'dateOfBirth',
  expiry: 'cardExpiry',
};

export { FRS_PATH_MAP, UI_STATE_FIELDS_TO_FORM_STATE_MAP };
